export default "__VITE_ASSET__CGxIMy7V__"